import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@mobi/component-library/Base/Buttons'
import { measurements, spacing } from '@mobi/component-library/Foundations'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { InfoHeader } from '@mobi/component-library/Typography/InfoHeader'
import { AppRoutes } from '@core/AppRoutes'
import { KAMBI_CONTAINER_BG_COLOR } from '@core/Areas/KambiClient/constants'
import { useAppSeoForSports } from '@core/Utils/hooks/useAppSeo/Sports/useAppSeoForSports'
import { appHistory } from '@core/Utils/routing/history'

export const MaintenanceScreen: React.FC<{ endDate: string }> = ({ endDate }) => {
  useAppSeoForSports({ page: 'sports', data: { sportName: 'Sports' } })

  return (
    <ContainerStyled>
      <InfoHeader
        icon='info'
        header='Sports is Unavailable Due to Maintenance'
        subHeader={
          <Flex flexDirection='column' gap={spacing.sm}>
            <span>
              We expect to be back up and running by{' '}
              {new Date(endDate).toLocaleString('en-AU', {
                weekday: 'long',
                hour: 'numeric',
                minute: 'numeric',
              })}
            </span>
            <span>Our customer service centre can be contacted on 1300 36 36 88</span>
            <Button color='primary' onClick={() => appHistory.push(AppRoutes.Home)}>
              Return to Home Page
            </Button>
          </Flex>
        }
      />
    </ContainerStyled>
  )
}

// ======
// Styles
// ======

const ContainerStyled = styled.div({
  boxSizing: 'border-box',
  width: '100%',
  minHeight: `calc(100vh - ${measurements.mobi.headerHeight})`,
  padding: spacing.sm,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: KAMBI_CONTAINER_BG_COLOR,
  fontSize: '4rem',
})
